import type * as api from '@owl-nest/api-client/latest'
import * as models from '@owl-nest/models'
import { searchParams } from '@owl-nest/utils'

export function getCheckoutURL(
  projectID: number,
  params?: {
    donationFrequency?: models.project.DonationFrequency
    optionValuesIds?: string[]
    rewardID?: number
    tipAmount?: number
  },
): string {
  return searchParams.addSearchParamsToUrl(`/projects/${projectID}/checkout`, {
    ...(params?.donationFrequency !== undefined && { frequency: params?.donationFrequency }),
    ...(params?.optionValuesIds !== undefined && { valuesIds: params?.optionValuesIds.join(',') }),
    ...(params?.rewardID !== undefined && { reward: params?.rewardID }),
    ...(params?.tipAmount !== undefined && { tip: params?.tipAmount }),
  })
}

export const getAddNewsURL = (project: api.Project): string => {
  return project.urls.web.edit.news.add
}
